import styled from 'styled-components';

export const ChartContainer = styled.div<{ $overrideStyles: boolean }>`
  width: 100%;
  height:  ${({ $overrideStyles }) => $overrideStyles ? '400px' : '500px'};
  padding: ${({ $overrideStyles }) => $overrideStyles ? '0px' : '50px 90px'};
  .spider-corner {
    font-size: 9px;
    &:hover {
      cursor: pointer;
      color: orange;
    }
  }
`;
